module.exports = __webpack_public_path__ + "images/category_lp/jewel/store_images/5_e835cb44b18506483043c4db2e55e63b.png";